import BuyElectronicBillsPage from "./BuyElectronicBillsPage";

export default BuyElectronicBillsPage;
